import createReducer from './../lib/createReducer';
import * as types from './../actions/types';

export const staffManagement = createReducer(
  {
    list: [],
  },
  {
    [types.GET_STAFF_LIST_START](state) {
      const newState = Object.assign({}, state, {
        loading: true,
      });

      return newState;
    },
    [types.GET_STAFF_LIST_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        list: action.list,
        loading: false,
      });
      return newState;
    },
    [types.GET_STAFF_LIST_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        error: action.error,
        loading: false,
      });
      return newState;
    },
    [types.ADD_STAFF_START](state) {
      const newState = Object.assign({}, state, {
        adding: true,
        staffadded:false
      });

      return newState;
    },
    [types.ADD_STAFF_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        list: action.list,
        adding: false,
        staffadded:true
      });
      return newState;
    },
    [types.ADD_STAFF_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        error: action.error,
        adding: false,
        staffadded:false
      });
      return newState;
    },
    [types.UPDATE_STAFF_INFO_START](state) {
      const newState = Object.assign({}, state, {
        updatinginfo: true,
        infoupdated:false
      });

      return newState;
    },
    [types.UPDATE_STAFF_INFO_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        updatinginfo: false,
        infoupdated:true
      });
      return newState;
    },
    [types.UPDATE_STAFF_INFO_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        error: action.error,
        updatinginfo: false,
        infoupdated:false
      });
      return newState;
    },
    [types.UPDATE_STAFF_PASSWORD_START](state) {
      const newState = Object.assign({}, state, {
        updatingpassword: true,
        passwordupdated:false
      });

      return newState;
    },
    [types.UPDATE_STAFF_PASSWORD_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        updatingpassword: false,
        passwordupdated:true
      });
      return newState;
    },
    [types.UPDATE_STAFF_PASSWORD_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        error: action.error,
        updatingpassword: false,
        passwordupdated:false
      });
      return newState;
    },
    [types.DELETE_STAFF_START](state) {
      const newState = Object.assign({}, state, {
        deleteuser: true,
        deletedstaff:false
      });

      return newState;
    },
    [types.DELETE_STAFF_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        deleteuser: false,
        deletedstaff:true
      });
      return newState;
    },
    [types.DELETE_STAFF_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        error: action.error,
        deleteuser: false,
        deletedstaff:false
      });
      return newState;
    },
  },
);

export { staffManagement as default };
